import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { Checkbox, Input, InputDate, InputPhone, Select } from 'components/fields'
import { Modal } from 'containers/misc'
import { ConfirmBox, Module } from 'components/misc'
import { consentTypes } from 'redux/selectors/codeLists'
import { CONFIGURATION_KEYS, CONSENT_DELIVERY_TYPES, PAYMENTS, PROGRESS_STATES } from 'constants/enums'

export default class ParticipantParent extends PureComponent {
  static propTypes = {
    disabled: PropTypes.bool,
    modal: PropTypes.func,
    resendParentalConsentLink: PropTypes.func.isRequired,
    data: PropTypes.object,
    consentDeliveryTypes: PropTypes.array.isRequired,
    fieldPrefix: PropTypes.string,
    configuration: PropTypes.object.isRequired,
    onGetOrganizationParentalConsentConfiguration: PropTypes.func.isRequired,
    notification: PropTypes.func.isRequired
  }

  componentDidMount () {
    const { data } = this.props

    if (!data.organization) {
      return
    }

    this.props.onGetOrganizationParentalConsentConfiguration(
      data.organization.id
    )
  }

  handleResendConsent = () => {
    const canResendParentalConsent = this.canResendParentalConsent()

    if (canResendParentalConsent) {
      this.props.modal('modal-resend-parental-link')
    } else {
      this.props.notification('Parent email must be filled in', {
        status: 'error',
        intlKey: 'error.parent_email_must_be_filled'
      })
    }
  }

  canResendParentalConsent = () => {
    const {
      data
    } = this.props

    const paymentType = get(data, 'participantRegistration.paymentType', {})

    let canResendParentalConsent =
      !data.isConsentDeliveryConfirmed &&
      (get(data, 'consentDeliveryType.value') ===
        CONSENT_DELIVERY_TYPES.electronically.id ||
        get(paymentType, 'value') === PAYMENTS.ONLINE_MASTERCARD.id) &&
      (get(data, 'awardState.value') === PROGRESS_STATES.awardRegApproval.id ||
        get(data, 'awardState.value') === PROGRESS_STATES.awardRegAssessment.id)

    const parentEmail = get(data, 'participantRegistration.parentEmail')

    canResendParentalConsent = canResendParentalConsent && parentEmail

    return canResendParentalConsent
  }

  handleCloseModal = () => this.props.modal(null)

  render () {
    const {
      consentDeliveryTypes,
      disabled,
      fieldPrefix,
      data,
      configuration
    } = this.props

    let configKeys = []

    const organisationId = get(data, 'organization.id')

    if (organisationId) {
      if (configuration.valuesByOrganizationId[organisationId]) {
        configKeys = [
          configuration.valuesByOrganizationId[organisationId][
            CONFIGURATION_KEYS
              .participantRegistrationParentalConsentElectronically.id
            ],
          configuration.valuesByOrganizationId[organisationId][
            CONFIGURATION_KEYS.participantRegistrationParentalConsentNotRequired
              .id
            ],
          configuration.valuesByOrganizationId[organisationId][
            CONFIGURATION_KEYS.participantRegistrationParentalConsentPaper.id
            ]
        ]
      }
    }

    const types = consentTypes(consentDeliveryTypes, configKeys)

    const prefix = '' || fieldPrefix

    const canResendParentalConsent = this.canResendParentalConsent()

    const buttonDefinition = [
      {
        'order': 1,
        'secondary': true,
        'onClick': this.handleResendConsent,
        'iconAction': null,
        'isActionLoading': false,
        'intlKeyAction': 'button.resend_parental_consent',
        'action': canResendParentalConsent ? 'Resend parental consent' : null
      }
    ]

    return (
      <Module
        title="Parent/Guardian Consent"
        intlKey="moduleTitle.parent_consent"
        buttonDefinition={buttonDefinition}
        narrow
      >
        <div className="row">
          <div className="col-xs-6">
            <Select
              label="Parent&#39;s aggrement"
              intlKey="label.parent_agreement"
              disabled={disabled}
              name={`${prefix}consentDeliveryType.value`}
              options={types || []}
            />
          </div>
          <div className="col-xs-6">
            <Input
              label="Parent&#39;s relationship"
              intlKey="label.parent_relationship"
              disabled={disabled}
              name={`${prefix}participantRegistration.parentRelationship`}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <Input
              label="First name of Parent/Guardian"
              intlKey="label.parent_first_name"
              disabled={disabled}
              name={`${prefix}participantRegistration.parentFirstName`}
            />
          </div>
          <div className="col-xs-6">
            <Input
              label="Last name of Parent/Guardian"
              intlKey="label.parent_last_name"
              disabled={disabled}
              name={`${prefix}participantRegistration.parentLastName`}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <Input
              label="Parent&#39;s/Guardian&#39;s email"
              intlKey="label.parent_email"
              disabled={disabled}
              name={`${prefix}participantRegistration.parentEmail`}
            />
          </div>
          <div className="col-xs-6">
            <InputPhone
              label="Parent&#39;s/Guardian&#39;s phone number"
              intlKey="label.parent_phone"
              disabled={disabled}
              name={`${prefix}participantRegistration.parentPhone`}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <InputDate
              label="Date of delivery"
              intlKey="label.date_of_delivery"
              name={`${prefix}consentDeliveryDate`}
              disabled={disabled}
            />
          </div>
          <div className="col-xs-6">
            <Checkbox
              label="Delivery confirmed"
              intlKey="label.delivery_confirmed"
              name={`${prefix}isConsentDeliveryConfirmed`}
              disabled={disabled}
              justify
            />
          </div>
        </div>
        <Modal id="modal-resend-parental-link" customActions>
          <ConfirmBox
            onSecondaryClick={this.handleCloseModal}
            onClick={this.props.resendParentalConsentLink}
            title="Resend parental consent link?"
            titleIntlKey="moduleTitle.resend_parental_consent_link"
            data={{
              awardId: data.id
            }}
          />
        </Modal>
      </Module>
    )
  }
}
